import { checkRecaptcha } from './helpers.js';

(function () {
  const links = document.querySelectorAll('.--require-recaptcha');

  if (links.length > 0) {
    links.forEach((linkEl) => {
      linkEl.addEventListener('click', function (e) {
        e.preventDefault();
        checkRecaptcha().then((isValidated) => {
          if (isValidated) {
            const isPrintLink = linkEl.href === 'javascript:window.print()';
            if (isPrintLink) {
              window.print();
            } else {
              window.open(linkEl.href, '__blank');
            }
          }
        });
      });
    });
  }
})();
